export default __webpack_public_path__ + "static/media/BG-Yellow-0003.27c3f55b.png";